/**
 * @param {{dataLayer:any}} data
 */
const toLower = str => (str ? str.toLowerCase() : '');
const pathArray = window.location.pathname.split('/');
const page = pathArray.length > 1 ? pathArray[1] || 'home' : 'home';

export const navigationIds = {
  navigationHome: `${page}_navigation_home`,
  navigationJoin: `${page}_navigation_join`,
  navigationLogin: `${page}_navigation_login`,
  navigationLogout: `${page}_navigation_logout`,
  navigationSearch: `${page}_navigation_search`,
  navigationMobileToggle: `${page}_navigation_mobile_toggle_open`,
  computed: {
    navigationDropdown: id => `${page}_navigation_dropdown_${toLower(id)}`,
    navigationDropdownItem: (parentId, id) =>
      `${page}_navigation_dropdown_item_${toLower(parentId)}_${toLower(id)}`,
  },
};
